import {
  initateAuthRequest,
  authChallengeValidationRequest,
  startResetPasswordRequest,
  resetPasswordChallengeValidationRequest,
  updatePasswordRequest,
  startUpdateEmailRequest,
  updateEmailRequest,
  startUpdatePhoneNumberRequest,
  updatePhoneNumberRequest,
  resetPasswordRequest,
} from '@/services/auth';
import { useMutation } from '@tanstack/react-query';

export const useInitiateAuth = () => {
  const { mutateAsync: initateAuth, isPending: isLoadingInitateAuth } =
    useMutation({
      mutationFn: initateAuthRequest,
    });

  const {
    mutateAsync: authChallengeValidation,
    isPending: isLoadingAuthChallengeValidation,
  } = useMutation({
    mutationFn: authChallengeValidationRequest,
  });

  return {
    isLoadingInitateAuth,
    isLoadingAuthChallengeValidation,
    initateAuth,
    authChallengeValidation,
  };
};

export const useResetPassword = () => {
  const {
    mutateAsync: startResetPassword,
    isPending: isLoadingStartResetPassword,
  } = useMutation({
    mutationFn: startResetPasswordRequest,
  });

  const {
    mutateAsync: resetPasswordChallengeValidation,
    isPending: isLoadingResetPasswordChallengeValidation,
  } = useMutation({
    mutationFn: resetPasswordChallengeValidationRequest,
  });

  const { mutateAsync: resetPassword, isPending: isLoadingResetPassword } =
    useMutation({
      mutationFn: resetPasswordRequest,
    });

  return {
    isLoadingStartResetPassword,
    isLoadingResetPasswordChallengeValidation,
    isLoadingResetPassword,
    startResetPassword,
    resetPasswordChallengeValidation,
    resetPassword,
  };
};

export const useUpdatePassword = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: updatePasswordRequest,
  });

  return {
    isPending,
    updatePassword: mutateAsync,
  };
};

export const useUpdateEmail = () => {
  const { mutateAsync: startUpdateEmail, isPending: startUpdateEmailLoading } =
    useMutation({
      mutationFn: startUpdateEmailRequest,
    });

  const { mutateAsync: updateEmail, isPending: updateEmailLoading } =
    useMutation({
      mutationFn: updateEmailRequest,
    });

  return {
    startUpdateEmailLoading,
    updateEmailLoading,
    startUpdateEmail,
    updateEmail,
  };
};

export const useUpdatePhoneNumber = () => {
  const {
    mutateAsync: startUpdatePhoneNumber,
    isPending: startUpdatePhoneNumberLoading,
  } = useMutation({
    mutationFn: startUpdatePhoneNumberRequest,
  });

  const {
    mutateAsync: updatePhoneNumber,
    isPending: updatePhoneNumberLoading,
  } = useMutation({
    mutationFn: updatePhoneNumberRequest,
  });

  return {
    startUpdatePhoneNumberLoading,
    updatePhoneNumberLoading,
    startUpdatePhoneNumber,
    updatePhoneNumber,
  };
};
